var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 15,
    viewBox: "0 0 13.333 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24",
    d: "M162.5-825a1.6,1.6,0,0,1-1.177-.49,1.6,1.6,0,0,1-.49-1.177V-837.5H160v-1.667h4.167V-840h5v.833h4.167v1.667H172.5v10.833a1.6,1.6,0,0,1-.49,1.177,1.6,1.6,0,0,1-1.177.49Zm8.333-12.5H162.5v10.833h8.333Zm-6.667,9.167h1.667v-7.5h-1.667Zm3.333,0h1.667v-7.5H167.5Zm-5-9.167v0Z",
    transform: "translate(-160 840)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.ee7b931618f9bdcce7cd01a09569fe7d.svg";
export { ForwardRef as ReactComponent };